/**
 * Created by TzuHsing on 2020-02-15
 */

import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import AdvManage from './components/AdvManage'
import AdvPreview from './components/AdvPreview'
import './styles.css'
import { API_DOMAIN } from '../../config'
import { fetchData } from '../../util'
import * as actionsAdvManage from './action'
import * as actionsHome from '../Home/action'
import { CLUB_ID } from '../ClubBusiness/constants'
const actions = Object.assign({}, actionsAdvManage, actionsHome)

class CheckOutAdvManage extends React.Component {
  fetchQiuNiuToken = (that) => {
    return new Promise((resolve, reject) => {
      const endpoint = `${API_DOMAIN}/CommodityApi/getQiniuToken`
      fetchData(endpoint).then((data) => {
        that.setState({ qiuNiuToken: data.token })
        resolve(true)
      })
    })
  }

  render() {
    const {
      adv_uploadedList,
      adv_unpublishedList,
      adv_uncheckList,
      adv_deletedList,
      fetchAdvList,
      adv_unionList,
      fetchUnionAdvList,
      changeAdvInfo,
      addAdv,
      changeAdvState,
    } = this.props
    const clubId = sessionStorage.getItem(CLUB_ID)
    return (
      <div className="page_container">
        <AdvManage
          clubId={clubId}
          advList={{
            adv_uploadedList,
            adv_unpublishedList,
            adv_uncheckList,
            adv_deletedList,
          }}
          getAdvInfo={fetchAdvList}
          changeAdvInfo={changeAdvInfo}
          addAdv={addAdv}
          changeAdvState={changeAdvState}
          fetchQiuNiuToken={this.fetchQiuNiuToken}
        />
        <AdvPreview
          clubId={clubId}
          advClubList={adv_uploadedList}
          advUnionList={adv_unionList}
          getAdvInfo={fetchAdvList}
          fetchUnionList={fetchUnionAdvList}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    adv_uploadedList: state.getAdv.adv_uploadedList,
    adv_unpublishedList: state.getAdv.adv_unpublishedList,
    adv_uncheckList: state.getAdv.adv_uncheckList,
    adv_deletedList: state.getAdv.adv_deletedList,
    adv_unionList: state.getAdv.adv_unionList,
  }
}

export default withRouter(connect(mapStateToProps, actions)(CheckOutAdvManage))



// WEBPACK FOOTER //
// ./src/containers/CheckOutAdvManage/index.js